import { FC } from "react";
import { Breadcrumb } from "antd";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SkeletonBox from "@Components/SkeletonBox/SkeletonBox";

type Props = {
  brandName?: string;
  isFetching?:boolean;
};

const GiftcardDetailsHeaderWeb: FC<Props> = ({ brandName, isFetching }) => {
  const { t } = useTranslation();

  return (
    <Breadcrumb
      className="font-semibold!"
      classNames={{
        item:"flex! items-center!"
      }}
      items={[
        {
          title: <Link to="..">{t("Menu.giftcards")}</Link>,
        },
        {
          title: !isFetching ? <div className="font-bold!">{brandName}</div> : <SkeletonBox className="w-20 h-5"/>,
        },
      ]}
    />
  );
};

export default GiftcardDetailsHeaderWeb;
